/** Org-wide settings hub.
 *
 * Surfaces the display + security toggles together so admins don't
 * have to crawl four sidebar entries to flip basic things. Each card
 * gates on `org.update`, so non-admins land on the no-permission
 * fallback.
 */
import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { WaveScheduleEditor } from "@/modules/campaigns/WaveScheduleEditor";
import { NotifyPolicyEditor } from "@/modules/notifications/NotifyPolicyEditor";
import {
  CallAlertsCard,
  FieldGeoRequiredCard,
  OrgAddressCard,
  OrgContactsCard,
  OrgProfileCard,
  OtpRequiredCard,
  SmsOptInCard,
  TimezoneCard,
} from "@/modules/admin";


export default function AdminOrgSettingsPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.orgSettings.pageTitle")}
      description={t("admin.orgSettings.pageDescription")}
    >
      <PermissionGate
        perm="org.update"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <OrgProfileCard />
        <OrgAddressCard />
        <OrgContactsCard />
        <TimezoneCard />
        <OtpRequiredCard />
        <FieldGeoRequiredCard />
        <SmsOptInCard />
        {/* When the operator gets told a call is coming. Sits with the
            other operator-facing switches rather than with the
            beneficiary messaging below it. */}
        <CallAlertsCard />
        {/* The org-wide default every campaign follows until it is
            edited. Placed straight after the SMS opt-in because that
            switch is the hard gate above everything in here. */}
        <section className="card space-y-3">
          <NotifyPolicyEditor scope={{ kind: "org" }} />
        </section>
        {/* The org-wide wave schedule every campaign follows until it is
            edited. Replaced a single cron at 10:00 UTC. */}
        <section className="card space-y-3">
          <WaveScheduleEditor scope={{ kind: "org" }} />
        </section>
      </PermissionGate>
    </AppLayout>
  );
}
